import { FunctionalComponent, h } from "@stencil/core";

export interface FormControlProps {
    /**
     * The user-facing name of the control
     */
    label: string;

    /**
     * Text used to help users understand the input
     */
    helperText: string;

    /**
     * Whether the label should be displayed
     */
    hasLabel: boolean;

    /**
     * Whether the helper text should be displayed
     */
    hasHelperText: boolean;

    /**
     * The id of the HTML element hosting the helper text
     */
    helperTextId?: string;
    /**
     * The id of the HTML input element
     */
    controlId?: string;

    /**
     * Whether the form is invalid
     */
    invalid: boolean;
}

/**
 * Helper function to render controls with form-like props consistently
 * @param props The props
 * @param children The content projected from the calling component
 */
export const FormControl: FunctionalComponent<FormControlProps> = (props, children) => (
    <div
        class={{
            "uic-form-control": true,
            "uic-form-control--invalid": props.invalid,
            "uic-form-control--has-label": props.hasLabel,
            "uic-form-control--has-helper-text": props.hasHelperText
        }}
    >
        <label class='uic-form-control__label' htmlFor={props.controlId}>
            <slot name='label'>{props.label}</slot>
        </label>
        {children}
        <div class='uic-form-control__helper-text' id={props.helperTextId}>
            <slot name='helper-text'>{props.helperText}</slot>
        </div>
    </div>
);
